import React, { useEffect } from "react";
import { Box, Button } from "@mui/material";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import aiNative from "../../assets/images/Portrait_of_Software_Engineer.png";
import shelfLogo from "../../assets/images/TheShelf-Fullcolor-RGB.svg";
import styles from "../Login/login.module.scss";
import FastForwardIcon from "@mui/icons-material/FastForward";

const Login = () => {
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (isAuthenticated) {
      navigate("/landing", { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className={styles.loginPageContainer}>
      <div className={styles.splitContainer}>
        <div className={styles.leftSection}>
          <div className={styles.imageWrapper}>
            <img src={aiNative} alt="AI Native" className={styles.bgImgBlur} />

            <h1 className={styles.leftTitle}>
              Lead the Strategy. <br /> Let AI Scale it.
            </h1>
          </div>
        </div>
        <div className={styles.rightSection}>
          <Box className={styles.rightContent}>
            <div className={styles.logoContainer}>
              <img
                src={shelfLogo}
                alt="The Shelf logo"
                className={styles.logoImage}
              />
            </div>

            <p className={styles.tagline}>
              Built for an AI-native enterprise. Designed for impact.
            </p>
            <p className={styles.description}>
              Discover self-learning AI agents built for privacy, performance
              and control. Unlock a reimagined way of working where core
              processes are streamlined and individual performance is amplified.
              <br />
              Smarter. Faster. More intuitive.
            </p>
            <Button
              variant="contained"
              onClick={login}
              data-testid="login-button"
              className={styles.loginButton}
            >
              GET STARTED (BETA)
              <FastForwardIcon sx={{ color: "black" }} />
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default Login;
